import type { OptionRendererProps } from "@hoylu/client-common";
import { clsx } from "clsx";
import React from "react";
import Styles from "./ProjectOptionRenderer.module.css";
import { ProjectSelectorLabel } from "./ProjectSelectorLabel";
import type { ProjectOption } from "./types";

export const ProjectOptionRenderer = ({
  key,
  onClick,
  option,
  selected,
}: OptionRendererProps<ProjectOption>) => {
  const project = option.value;
  return (
    <div
      className={clsx(Styles.option, selected && Styles.selected)}
      key={key}
      onClick={() => {
        if (selected) return;

        onClick();
        option.value.onSelected?.();
      }}
    >
      <ProjectSelectorLabel
        color={project.color}
        endDate={project.endDate}
        hasAdmin={project.hasAdmin}
        icon={project.icon}
        name={option.label}
        status={project.status}
      />
    </div>
  );
};
